import { render, staticRenderFns } from "./UOttawa1701ExamCover2025Fr.vue?vue&type=template&id=35ec9e44&scoped=true&"
import script from "./UOttawa1701ExamCover2025Fr.vue?vue&type=script&lang=js&"
export * from "./UOttawa1701ExamCover2025Fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec9e44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSimpleTable,VTextField})
